<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <CauseOfMaintanceForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CauseOfMaintanceForm from '@/components/settings/test-registers/causeOfMaintance/CauseOfMaintanceForm'

export default {
  name: 'CauseOfMaintances',
  components: {
    PageTitle,
    PageRowWrapper,
    CauseOfMaintanceForm
  }
}
</script>
